import * as React from "react";
import { TravelScreenTemplate } from "./template";
import { useTravelScreen } from "./logic";

export const TravelScreen = (): JSX.Element => {
  const { user, ...logic } = useTravelScreen();

  return user ? <TravelScreenTemplate {...logic} /> : null;
};
